import { useContext } from 'react';
import {
  DeltaList,
  DeltaPrice,
  SelectionsLabel
} from '@/new-cars/Modals/ViewVehiclesModal/MatchingVehicleCard/MatchingVehicleCard.styles';
import SectionName from '~/constants/new-cars/SectionName';
import ParentModelContext from '~/context/new-cars/ParentModelContext';
import { VehicleDelta } from '~/hooks/new-cars/selectors/useMatchingVehiclesWithDeltas';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';

type OwnProps = {
  deltas: VehicleDelta[];
};

export default function DeltasContent({ deltas }: OwnProps) {
  const { activeSection } = useContext(ParentModelContext);

  return (
    <>
      <SelectionsLabel>
        {activeSection === SectionName.Options
          ? 'All your selections, plus'
          : 'Includes'}
      </SelectionsLabel>
      <DeltaList>
        {deltas.map(({ category, name, priceAdd }) => (
          <li key={`${category}-${name}`}>
            {name} <DeltaPrice>(${formatAndDropDecimal(priceAdd)})</DeltaPrice>
          </li>
        ))}
      </DeltaList>
    </>
  );
}
